import type { SensorData } from 'Simulations/SensorPoint';
import Grid from 'Geodata/grid';
import { ControllerManager } from '@gui/controller/ControllerManager';
import { BlockKeys } from '@data/Simulations/pipeline/BlockCatalog';

type DensityBlockParams = {
    enabled?: boolean;
    isOneEveryThree?: boolean;
};

export const ONE_TO_THREE_ENERGY_FACTOR = 3 * 3;

const isOneToThreeEnabled = (): boolean => {
    try {
        const pipelineController = ControllerManager.getInstance().getPipelineController();
        const densityBlockId = pipelineController.getBlockIdByType(BlockKeys.Density);
        if (!densityBlockId) return false;
        const params = pipelineController.getBlockParams(densityBlockId) as DensityBlockParams | undefined;
        if (!params?.enabled) return false;
        return !params.isOneEveryThree;
    } catch {
        return false;
    }
};

export function computeTotalEnergyFromSensors(sensors: SensorData[]): number {
    const valueSum = sensors.reduce((sum, sensor) => sum + sensor.getScalarValue(), 0);
    const gridRes = Grid.gridRes;
    const areaFactor = gridRes * gridRes;
    const isOneToThreeOn = isOneToThreeEnabled();
    const densityFactor = isOneToThreeOn ? ONE_TO_THREE_ENERGY_FACTOR : 1;
    return valueSum * areaFactor * densityFactor;
}
